<template>
    <v-card >
        <v-card-title>
            <div class="relacion-title">
                <strong>
                    <!-- {{ relacion.posicion || 1 }}. -->
                    {{ tratamiento.nombre }}

                    <v-btn
                        small
                        text
                        color="primary"
                        @click="onEdit(relacion)"
                    >
                        Editar
                    </v-btn>
                </strong>
                
                <span class="precio" v-if="relacion.show_precio">
                    {{ relacion.precio > 0 ? 'S/ ' + relacion.precio : 'gratis' }}
                </span>
            </div>

        </v-card-title>
        
        <!-- <v-card-text class="p-3" v-if="tratamiento.descripcion">
            {{ tratamiento.descripcion }}
        </v-card-text> -->
    </v-card>
</template>

<script>
export default {
    name: 'ShowRelacion',
    props: {
        relacion: {
            type: Object,
            required: true,
        },
        tratamientos: {
            type: Array,
            required: true,
        },
    },
    computed: {
        tratamiento() {
            return this.tratamientos.find(t => t.idtratamiento === this.relacion.idtratamiento) || {};
        }
    },
    methods: {
        onEdit(data) {
            this.$emit('onEdit', data);
        }
    }
};
</script>

<style scoped>
    .relacion-title {
        display: flex;
        gap: 8px;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        word-break: break-word;
    }
    .relacion-subtitle{
        display: flex;
        gap: 8px;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        font-size: 12px;
        color: #666;
    }
    .precio {
        text-wrap: nowrap;
    }
</style>